import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { archiveList } from "@/mocks/homeData";

const weightStyle: Record<string, string> = {
  高: "border-accent-300 bg-accent-50 text-accent-700",
  中: "border-primary-300 bg-primary-50 text-primary-700",
  低: "border-background-300 bg-background-100 text-foreground-600",
};

export default function Archive() {
  return (
    <section id="archive" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              eyebrow="PERSON ARCHIVE"
              title="人物档案：一条一条看，谁在做什么"
              description="每条记录都按「一句话概括 + 可核实的程度」写清楚。主角、配角与存疑节点分开排列，先认人，再谈关系。"
            />
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-label text-xs text-foreground-500">核实程度</span>
              {(["高", "中", "低"] as const).map((level) => (
                <span
                  key={level}
                  className={`rounded-full border px-2.5 py-1 font-label text-[11px] ${weightStyle[level]}`}
                >
                  {level}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-10 border-t border-background-200">
          {archiveList.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group grid grid-cols-1 gap-4 border-b border-background-200 py-6 md:grid-cols-12 md:gap-8 md:py-7">
                <div className="flex items-center gap-3 md:col-span-1 md:block">
                  <span className="font-heading text-2xl font-bold text-background-400 transition-colors duration-300 group-hover:text-primary-400 md:text-3xl">
                    {item.index}
                  </span>
                </div>

                <div className="md:col-span-8">
                  <h4 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    {item.title}
                  </h4>
                  <p className="mt-2.5 max-w-3xl text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>

                <div className="flex flex-row items-center justify-between gap-3 md:col-span-3 md:flex-col md:items-end md:justify-between">
                  <span className="rounded-md border border-background-200 bg-background-50 px-2.5 py-1 font-label text-[11px] text-foreground-600">
                    {item.tag}
                  </span>
                  <span
                    className={`rounded-full border px-2.5 py-1 font-label text-[11px] ${weightStyle[item.weight]}`}
                  >
                    可信度 {item.weight}
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-6 flex items-start gap-2 font-label text-xs leading-relaxed text-foreground-500">
            <i className="ri-file-list-3-line mt-0.5 text-sm text-secondary-500" />
            整理口径：凡是只有一个来源的说法，统一归入存疑并单独标注，不与已核实条目混排。
          </p>
        </Reveal>
      </div>
    </section>
  );
}